import { useTranslation } from 'react-i18next';

import { Button, Flex } from '@olist/united';

import { ButtonOpenModal } from './button-open-modal';

export interface IBankAccount {
  isSubmiting: boolean;
  setOpenModal: (value: any) => void;
}

export const BankAccountFormControls = ({ isSubmiting = false, setOpenModal }: IBankAccount) => {
  const { t } = useTranslation();

  return (
    <Flex flexDirection="column">
      <Flex
        flex="1"
        flexDirection={['column', 'column', 'column', 'column', 'row']}
        justifyContent={['flex-start', 'flex-start', 'flex-start', 'flex-start', 'space-between']}
      >
        <ButtonOpenModal
          role="button"
          icon="question-circle-outline"
          variation="link"
          px={0}
          mr="auto"
          mb={3}
          color="foundation.primaryDefault"
          onClick={setOpenModal}
        >
          {t`need help completing?`}
        </ButtonOpenModal>
        <Flex>
          <Button type="submit" loading={isSubmiting} variation="alternate">{t`submit`}</Button>
        </Flex>
      </Flex>
    </Flex>
  );
};
